/**
 * Created by JasonChou on 17/6/14.
 */
import React, {PureComponent} from 'react'
import {imageCut} from '../utils/uiUtils'
import Image from './Image'
export default class NetImage extends PureComponent {
    render() {
        const {w, h, cut = true, ...other} = this.props;

        if (other.source && other.source.uri && cut) {
            let width, height;
            if (!w && !h && other.style) {
                width = other.style.width;
                height = other.style.height;
            } else {
                width = w;
                height = h;
            }

            other.source.uri = imageCut(other.source.uri, {width, height});
        }

        return (
            <Image
                {...other}/>
        );

        // 测试时查看url
        // return (<View>
        //     <Image
        //         style={[style]} {...other}/>
        //     <Text>{other.source.uri}</Text>
        // </View>);
    }
};


// WEBPACK FOOTER //
// ./src/components/NetImage.js